import { Stack } from '@mui/material';
import { AngleUnits } from 'convert-units/definitions/angle';

import { Datum } from '@/components/data/Datum';
import { SpreadIcon } from '@/components/data/SpreadIcon';
import { minorTextGrey } from '@/theme';

export type SpreadDatumProps = { spread: number; unit: AngleUnits };

export const SpreadDatum = ({ spread, unit = 'deg' }: SpreadDatumProps) => (
    <Stack direction="row" gap={0.5} alignItems="center">
        <SpreadIcon
            sx={{ color: minorTextGrey, fontSize: '1em' }}
            spread={spread}
            heading={0}
            unit={unit}
            type="flow"
        />
        <Datum value={spread} sourceUnit={unit} targetUnit="deg" type="angle" />
    </Stack>
);
